// Applies the welcome discount code to the cart when the newsletter popup is submitted successfully.
(function () {
  'use strict';

  var STORAGE_KEY = 'carddo_welcome_applied';

  function safeGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  function getConfig() {
    var cfg = (window.theme && window.theme.welcomeDiscount) || {};
    return {
      enabled: cfg.enabled !== false,
      code: (cfg.code || '').trim(),
      percent: cfg.percent || 0
    };
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function isWelcomeApplied(cart, code) {
    if (!cart || !cart.discount_codes || !code) return false;
    var codeLower = code.toLowerCase();
    for (var i = 0; i < cart.discount_codes.length; i++) {
      var dc = cart.discount_codes[i];
      if (dc.code && dc.code.toLowerCase() === codeLower && dc.applicable !== false) return true;
    }
    return false;
  }

  function findWelcomeEntry(cart, code) {
    if (!cart || !cart.discount_codes || !code) return null;
    var codeLower = code.toLowerCase();
    for (var i = 0; i < cart.discount_codes.length; i++) {
      var dc = cart.discount_codes[i];
      if (dc.code && dc.code.toLowerCase() === codeLower && dc.applicable !== false) return dc;
    }
    return null;
  }

  function buildCodesParam(cart, code) {
    var codes = [];
    if (cart && cart.discount_codes) {
      cart.discount_codes.forEach(function (dc) {
        // Only carry forward codes that are currently applying — stale/invalid
        // attempts (applicable:false) would otherwise be resubmitted forever.
        if (dc.code && dc.applicable !== false && codes.indexOf(dc.code) === -1) codes.push(dc.code);
      });
    }
    var lower = codes.map(function (c) { return c.toLowerCase(); });
    if (code && lower.indexOf(code.toLowerCase()) === -1) codes.push(code);
    return codes.join(',');
  }

  function applyDiscount(cb) {
    var cfg = getConfig();
    if (!cfg.enabled || !cfg.code) { if (cb) cb(); return; }
    fetchCart().then(function (cart) {
      var param = buildCodesParam(cart, cfg.code);
      fetch('/discount/' + encodeURIComponent(param), { credentials: 'same-origin' })
        .then(function () { safeSet(STORAGE_KEY, '1'); refreshCartUI(cb); })
        .catch(function () { refreshCartUI(cb); });
    }).catch(function () {
      fetch('/discount/' + encodeURIComponent(cfg.code), { credentials: 'same-origin' })
        .then(function () { safeSet(STORAGE_KEY, '1'); refreshCartUI(cb); })
        .catch(function () { if (cb) cb(); });
    });
  }

  function refreshCartUI(cb) {
    // NOTE: must not call theme.miniCart.updateElements() here — it adds the
    // 'active' class to the drawer (theme.js), which pops the mini-cart open.
    // This runs silently on every page load / cart refresh, so doing that was
    // forcing the cart drawer open with no user action (reported on mobile).
    fetchCart().then(function (cart) {
      document.querySelectorAll('.js-cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      renderDrawerDiscountLabel(cart);
      renderCartPageSummary(cart);
      renderCartPageLines(cart);
      if (cb) cb(cart);
    }).catch(function () { if (cb) cb(); });
  }

  function renderDrawerDiscountLabel(cart) {
    var cfg = getConfig();
    var isWelcome = isWelcomeApplied(cart, cfg.code);
    var label = isWelcome ? ('Descuento de bienvenida (-' + cfg.percent + '%)') : 'Descuentos';
    document.querySelectorAll('.js-cart-discount-label').forEach(function (el) {
      el.textContent = label;
    });
    document.querySelectorAll('.js-welcome-discount-note').forEach(function (el) {
      el.style.display = isWelcome ? '' : 'none';
    });
  }

  function renderCartPageSummary(cart) {
    var cfg = getConfig();
    var entry = findWelcomeEntry(cart, cfg.code);
    document.querySelectorAll('.js-welcome-discount-row').forEach(function (el) {
      if (entry) {
        el.style.display = '';
        var amountEl = el.querySelector('.js-welcome-discount-amount');
        if (amountEl && window.theme && window.theme.Currency) {
          amountEl.textContent = '-' + window.theme.Currency.formatMoney(cart.total_discount, window.theme.moneyFormat);
        }
      } else {
        el.style.display = 'none';
      }
    });
  }

  function renderCartPageLines(cart) {
    if (!cart || !cart.items || !window.theme || !window.theme.Currency) return;
    var rows = document.querySelectorAll('#CartProducts tr[data-line]');
    rows.forEach(function (row) {
      var line = parseInt(row.getAttribute('data-line'), 10);
      var item = cart.items[line - 1];
      if (!item) return;
      var hasDiscount = item.original_line_price !== item.line_price;
      var html = '';
      if (hasDiscount) {
        html += '<small class="cart-item__original-price cart__item-total"><s>' +
          window.theme.Currency.formatMoney(item.original_line_price, window.theme.moneyFormat) + '</s></small><br>';
      }
      html += '<span class="cart__item-total text-body">' +
        window.theme.Currency.formatMoney(item.line_price, window.theme.moneyFormat) + '</span>';
      var titles = [];
      (item.discounts || []).forEach(function (d) {
        if (d.title && titles.indexOf(d.title) === -1) titles.push(d.title);
      });
      titles.forEach(function (title) {
        html += '<p class="cart-item__discount cart__item-total">' + title + '</p>';
      });
      row.querySelectorAll('.js-line-price').forEach(function (el) {
        el.innerHTML = html;
      });
    });
  }

  function maybeReapplyOnAdd() {
    var cfg = getConfig();
    if (!cfg.enabled || !cfg.code) return;
    if (safeGet(STORAGE_KEY) !== '1') return;
    fetchCart().then(function (cart) {
      if (cart.item_count === 0) return;
      if (!isWelcomeApplied(cart, cfg.code)) applyDiscount();
    });
  }

  function installReapplyHook() {
    if (!window.theme || !window.theme.miniCart || !window.theme.miniCart.generateCart) return;
    if (window.theme.miniCart.__carddoWelcomeWrapped) return;
    var originalGenerateCart = window.theme.miniCart.generateCart;
    window.theme.miniCart.generateCart = function () {
      originalGenerateCart.apply(this, arguments);
      maybeReapplyOnAdd();
    };
    window.theme.miniCart.__carddoWelcomeWrapped = true;
  }

  function handleNewsletterSuccess() {
    var successEls = document.querySelectorAll('.js-newsletter-success');
    if (!successEls.length) return;
    successEls.forEach(function (el) {
      var modal = el.closest('.modal');
      if (modal && window.jQuery) window.jQuery(modal).modal('show');
    });
    applyDiscount();
  }

  function isSubscribed() {
    // NOTE: the 'cookiesNewsletter' cookie only means "don't auto-pop on scroll
    // for a while" (set on close OR submit) — it does NOT mean the visitor
    // actually subscribed, so it must not be used here.
    if (safeGet(STORAGE_KEY) === '1') return true;
    return false;
  }

  function showNewsletterPopup() {
    var container = document.querySelector('[data-section-type="popupnewletter"]');
    if (!container) return;
    if (container.getAttribute('data-has-orders') === 'true') return; // returning customer
    var modal = container.querySelector('.modal.fade');
    if (modal && window.jQuery) window.jQuery(modal).modal('show');
  }

  function maybeShowPopupOnFirstAdd() {
    var already;
    try { already = window.sessionStorage.getItem('carddo_add_popup_shown'); } catch (e) { already = null; }
    if (already === '1') return;
    try { window.sessionStorage.setItem('carddo_add_popup_shown', '1'); } catch (e) {}
    if (isSubscribed()) return;
    setTimeout(showNewsletterPopup, 900);
  }

  function installAddToCartWatcher() {
    function handleResponseUrl(url, ok) {
      if (!ok || !url || String(url).indexOf('/cart/add') === -1) return;
      maybeShowPopupOnFirstAdd();
    }

    var OrigXHR = window.XMLHttpRequest;
    if (OrigXHR && !OrigXHR.prototype.__carddoWrapped) {
      var origOpen = OrigXHR.prototype.open;
      var origSend = OrigXHR.prototype.send;
      OrigXHR.prototype.open = function (method, url) {
        this.__carddoUrl = url;
        return origOpen.apply(this, arguments);
      };
      OrigXHR.prototype.send = function () {
        this.addEventListener('load', function () {
          handleResponseUrl(this.__carddoUrl, this.status >= 200 && this.status < 300);
        });
        return origSend.apply(this, arguments);
      };
      OrigXHR.prototype.__carddoWrapped = true;
    }

    var origFetch = window.fetch;
    if (origFetch && !window.__carddoFetchWrapped) {
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url);
        return origFetch.apply(this, arguments).then(function (res) {
          handleResponseUrl(url, res && res.ok);
          return res;
        });
      };
      window.__carddoFetchWrapped = true;
    }
  }

  function init() {
    installReapplyHook();
    installAddToCartWatcher();
    handleNewsletterSuccess();

    var cfg = getConfig();
    if (!cfg.enabled || !cfg.code) return;
    fetchCart().then(function (cart) {
      if (isWelcomeApplied(cart, cfg.code)) {
        renderDrawerDiscountLabel(cart);
        renderCartPageSummary(cart);
        return;
      }
      if (cart.item_count > 0 && safeGet(STORAGE_KEY) === '1') {
        applyDiscount();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
